// Copyright © 2019 3D Robotics. All rights reserved.

import { withRouter } from "react-router-dom";

const WithRouter = ({ children, ...props }) => children(props);

export default withRouter(WithRouter);
